import tagsTemplates from './tagsTemplates';

import {
  Standard,
  Draggable,
  Filter,
  Toggle
} from './tagsLayouts';
import { FILTERTAGS } from 'elements/Tags/constants';

const tagsSet = [
  {
    type: 'standard',
    previews: [
      {
        component: Standard,
        codeTemplate: tagsTemplates.standard,
        optionsGroup: [
          {
            label: 'Primary',
            options: [
              {label: 'Only Text', type: 'radio', options: {withClose: false}},
              {label: 'With Clear', type: 'radio', options: {withClose: true}},
            ]
          }
        ]
      },
      {
        component: Standard,
        codeTemplate: tagsTemplates.standard,
        optionsGroup: [
          {
            label: 'Secondary',
            options: [
              {label: 'Only Text', type: 'radio', options: { secondary: true, icon: {}}},
              {label: 'With Icon', type: 'radio', options: { secondary: true, icon: { name:'hot-deals-fill', type: '15' }}},
            ]
          }
        ]
      }
    ]
  },
  {
    type: 'draggable',
    previews: [
      {
        component: Draggable,
        codeTemplate: tagsTemplates.draggable,
        optionsGroup: [
          {
            label: 'Draggable',
            options: [
              {label: 'Desktop', type: 'radio', options: {}},
              {label: 'iPad', type: 'radio', options: {}},
            ]
          }
        ]
      }
    ]
  },
  {
    type: 'filters',
    previews: [
      {
        component: Filter,
        codeTemplate: tagsTemplates.filter,
        optionsGroup: [
          {
            label: 'Filters',
            options: [
              {label: 'Only Text', type: 'radio', options: { status: '', icon: {} }},
              {label: 'With Colour Status', type: 'radio', options: { icon: {}, status: FILTERTAGS['success'] }},
              {label: 'With icon (10px)', type: 'radio', options: { status: '', icon: { name: 'arrow-up-10', type: 'other'} }},
              {label: 'With icon (15px)', type: 'radio', options: { status: '', icon: { name: 'star-fill', type: '15'} }},
            ]
          },
          {
            label: 'Colour:',
            options: [
              {label: 'Grey', type: 'radio', options: { bgColor: null, white: false }},
              {label: 'White', type: 'radio', options: { bgColor: 'black', white: true }}
            ]
          }
        ]
      },
      {
        component: Toggle,
        codeTemplate: tagsTemplates.toggle,
        optionsGroup: [
          {
            label: 'Toggle',
            options: [
              {label: 'Grey', type: 'radio', options: { white: false }},
              {label: 'White', type: 'radio', options: { white: true }}
            ]
          }
        ]
      }
    ]
  },
  {
    type: 'other sizes',
    previews: [
      {
        component: Standard,
        codeTemplate: tagsTemplates.standard,
        optionsGroup: [
          {
            label: 'Other Sizes',
            options: [
              {label: 'Large', type: 'radio', options: {large: true, small: false}},
              {label: 'Small', type: 'radio', options: {large: false, small: true}}
            ]
          }
        ]
      }
    ]
  }
];

export default tagsSet;


// WEBPACK FOOTER //
// ./src/containers/elements/Tags/constants/tagsSet.js